import { render, staticRenderFns } from "./SelectCustomer.vue?vue&type=template&id=d2504e28&scoped=true"
import script from "./SelectCustomer.vue?vue&type=script&lang=js"
export * from "./SelectCustomer.vue?vue&type=script&lang=js"
import style0 from "./SelectCustomer.vue?vue&type=style&index=0&id=d2504e28&prod&lang=scss&scoped=true"
import style1 from "./SelectCustomer.vue?vue&type=style&index=1&id=d2504e28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2504e28",
  null
  
)

export default component.exports